module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelManagerPage', {
    attrs: {
      "lower-app-name": "emarket",
      "lower-model-name": "goods",
      "version": "2",
      "obj-label": "商品"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-673e10cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/GoodsManager.vue
// module id = 378
// module chunks = 1